import { styled } from 'styled-components';

import { colors, cssBreakpoints, spacing, transition } from 'theme/theme';

export const ViewJobPageSidebarResultsHeaderHolder = styled.header`
  padding: 0 0 ${spacing[4]} 0;
  border-bottom: 1px solid ${colors.selectionGrey};
  width: 100%;
`;

export const ViewJobPageSidebarResultsHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 0 auto;
  max-width: 738px;
  transition: min-width ${transition};
`;

export const ViewJobPageSidebarResultsHeaderLeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const ViewJobPageSidebarResultsHeaderLeftSideSort = styled.div`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const ViewJobPageSidebarResultsHeaderRightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
